import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react';
import { CrashState } from './ErrorPage';

interface State {
  error: Error | null;
}

/**
 * Last line of defence: a render crash in one route should not blank the whole
 * console. React has no hook equivalent, so this stays a class component.
 */
export class AppErrorBoundary extends Component<PropsWithChildren<{ fallback?: ReactNode }>, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Swap for the real reporter (Sentry) once DSN wiring lands.
    console.error('Unhandled UI error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.fallback) return this.props.fallback;
    return <CrashState message={this.state.error.message} />;
  }
}
